module.exports = __webpack_public_path__ + "static/media/icon-manuals.ad431676.svg";